module.exports = __webpack_public_path__ + "media/6.d4a1a696.wav";